// Tables
export const FIRESTORE_REGIONS_TABLE = "regions";
export const FIRESTORE_ORDERS_TABLE = "farmorders";
export const FIRESTORE_PRODUCTS_TABLE = "products";
export const FIRESTORE_CUSTOMERS_TABLE = "customers";
export const FIRESTORE_USERS_TABLE = "users";
export const FIRESTORE_INVITED_USERS_TABLE = "invitedUsers";
export const FIRESTORE_NOTIFICATIONS_TABLE = "notifications";
export const FIRESTORE_CUSTOMER_REQUESTS_TABLE = "customer_requests";
export const FIRESTORE_CUSTOMER_GROUPS_TABLE = "customerGroups";
export const FIRESTORE_DISCOUNT_CODES_TABLE = "discountCodes";
export const FIRESTORE_PRODUCTS_STOCK_TABLE = "productStocks";
export const FIRESTORE_USER_PERMISSIONS_TABLE = "userPermissions";
export const FIRESTORE_ORDERPICKINGS_TABLE = "orderPickings";
export const FIRESTORE_CHAT_SESSIONS_TABLE = "chatSessions";
export const FIRESTORE_INVOICES_TABLE = "invoices";
export const FIRESTORE_COMPLAINTS_TABLE = "complaints";
export const FIRESTORE_ORDER_DELIVERIES_TABLE = "orderDeliveries";
export const FIRESTORE_LEADS_TABLE = "leads";
export const FIRESTORE_CHATBOT_DATA_SOURCES_TABLE = "chatbotDataSources";
export const FIRESTORE_PRICE_LISTS_TABLE = "priceLists";
export const FIRESTORE_PACKAGING_STOCKS_TABLE = "packagingStocks";
export const FIRESTORE_PACKAGING_STOCK_SNAPSHOTS_TABLE = "packagingStockSnapshots";
export const FIRESTORE_CRATE_STOCKS_TABLE = "crateStocks";
export const FIRESTORE_CRATE_STOCK_LOGS_TABLE = "cratesStockLog";
export const FIRESTORE_PRODUCT_REJECTS_TABLE = "productRejects";
export const FIRESTORE_PRODUCT_REJECT_REASONS_DOC = "defaultReasons";
export const FIRESTORE_COUNTRIES_TABLE = "countries";
export const FIRESTORE_RECONCILIATION_RUNS_COLLECTION = "reconciliationRuns";
export const FIRESTORE_EDI_LOG_COLLECTION = "ediLog";
export const FIRESTORE_SETTINGS_TABLE = "settings";

// Documents
export const FIRESTORE_DEFAULT_PROJECTIONS_DOC = "default_projections";
export const FIRESTORE_ROLE_PERMISSIONS_DOC = "role_permissions";
export const FIRESTORE_ACQUISITION_DEFAULTS_DOC = "acquisitionDefaults";
export const FIRESTORE_WHATSAPP_TEMPLATES_DOC = "whatsappTemplates";
